<template>
  <page-edicion v-if="this.ready" :title="nombreModulo">
    <page-header :title="modulo.nombre" subtitle="Importes y cuotas" back-to="/modulos" />
    <b-form v-for="(tarifa, idx) in tarifas" :key="tarifa.id" @submit.prevent="guardarPrecios(tarifa.id)">
      <details :open="idx == 0">
        <summary>{{ tarifa.nombre }}</summary>
        <formulario-planes-precios
          :divisas="divisas"
          :planes="planes"
          :modulo="modulo"
          :tarifa="tarifa"
          :precios="precios[tarifa.id]"
        />
        <div class="text-right">
          <b-button type="submit" variant="primary" class="mt-3">Guardar</b-button>
        </div>
      </details>
    </b-form>
  </page-edicion>
</template>

<script>
import FormularioPlanesPrecios from "./FormularioPlanesPrecios.vue";
import * as modulosApi from "@/services/modulos.js";
import planesApi from "@/services/planes.js";
import * as divisasApi from "@/services/divisas.js";
import tarifasApi from "@/services/tarifas.js";
import * as TipoModulo from "@/enums/TipoModulo";

function agruparPrecios(tarifas, planes, divisas, precios) {
  const agrupados = {};

  for (const tarifa of tarifas) {
    agrupados[tarifa.id] = {};
    for (const plan of planes) {
      agrupados[tarifa.id][plan.id] = {};
      for (const divisa of divisas) {
        agrupados[tarifa.id][plan.id][divisa.id] = {
          tarifaId: tarifa.id,
          planId: plan.id,
          divisaId: divisa.id,
          precioSuscripcion: 0,
          precioCuotaAnual: 0,
          precioServicio: 0,
        };
      }
    }
  }

  for (const precio of precios) {
    agrupados[precio.tarifaId][precio.planId][precio.divisaId] = precio;
  }

  return agrupados;
}

function desagruparPrecios(tarifaId, precios) {
  const desagrupados = [];
  for (let planId in precios[tarifaId]) {
    for (let divisaId in precios[tarifaId][planId]) {
      desagrupados.push(precios[tarifaId][planId][divisaId]);
    }
  }
  return desagrupados;
}

export default {
  components: { FormularioPlanesPrecios },
  data() {
    return {
      ready: false,
      moduloId: 0,
      modulo: {},
      planes: [],
      divisas: [],
      precios: [],
      tarifas: [],
    };
  },
  computed: {
    nombreModulo() {
      if (this.modulo.tipo == TipoModulo.SERVICIO) {
        return `Servicio: ${this.modulo.nombre}`;
      } else {
        return `Módulo: ${this.modulo.nombre}`;
      }
    },
  },
  async mounted() {
    await this.cargar(this.$route.params.id);
    this.ready = true;
  },
  methods: {
    async cargar(moduloId) {
      this.moduloId = moduloId;
      const data = await Promise.all([
        modulosApi.cargar(moduloId),
        modulosApi.cargarPrecios(moduloId),
        planesApi.listar(),
        divisasApi.listar(),
        tarifasApi.listarActivas(),
      ]);

      const modulo = data[0];
      const precios = data[1];
      const planes = data[2];
      const divisas = data[3];
      const tarifas = data[4];

      this.modulo = modulo;
      this.precios = agruparPrecios(tarifas, planes, divisas, precios);
      this.planes = planes;
      this.divisas = divisas;
      this.tarifas = tarifas.sort((a, b) => a.orden - b.orden);
    },
    async guardarPrecios(tarifaId) {
      const desagrupados = desagruparPrecios(tarifaId, this.precios);
      await modulosApi.guardarPreciosTarifa(this.moduloId, tarifaId, desagrupados);
      this.$bvToast.toast("Precios guardados correctamente.", {
        title: "Éxito",
        variant: "success",
        solid: true,
      });
    },
  },
};
</script>
<style scoped>
details {
  padding: 10px;
  background-color: #e4eaef;
  line-height: 2em;
  border-radius: 5px;
  margin-top: 5px;
}

details::details-content {
  opacity: 0;
  overflow: hidden;
  transition: all 450ms, content-visibility 200ms allow-discrete;
}

details[open]::details-content {
  opacity: 1;
  height: auto;
  background: white;
  border-radius: 10px;
  padding: 1em;
}
</style>
